
























































































import { defineComponent, reactive, ref } from '@vue/composition-api'

import Layout from '../organisms/common/Layout.vue'
import { resetPassword } from '../../api/users'
import { passwordSettingUrl } from '../../router/index'
export default defineComponent({
  name: 'InputEmail',
  components: { Layout },
  setup(props, context) {
    const model = reactive({
      code: '',
      mail: '',
    })
    const loading = ref(false)
    const failed = ref(false)
    const sended = ref(false)
    const form = ref<HTMLFormElement | null>(null)
    const validate = () => {
      if (!form.value) {
        return false
      }
      return form.value?.validate()
    }
    const getPath = () => {
      return context.root.$router.resolve({ name: 'PasswordSetting' })
    }
    const sendMail = async () => {
      if (!validate()) {
        return
      }
      loading.value = true
      try {
        await resetPassword({
          code: model.code,
          mail: model.mail,
          url: passwordSettingUrl,
        })
        loading.value = false
        sended.value = true
      } catch (error) {
        failed.value = true
        loading.value = false
      }
    }
    const codeRules = [(v: any) => !!v || 'ユーザーIDは必須項目です。']
    const emailRules = [
      (v: any) => !!v || 'メールアドレスは必須項目です',
      (v: any) => /.+@.+/.test(v) || 'メールアドレスが正しくありません',
    ]

    return {
      model,
      loading,
      failed,
      sended,
      form,
      getPath,
      sendMail,
      codeRules,
      emailRules,
    }
  },
})
